export const ANALYTICS_USER_TOKEN = 'user_token';
export const ANALYTICS_COMPANY = 'company';
export const ANALYTICS_PARAM_NAME = 'ok-soon-ai-analytics';
export const ANALYTICS_QUERY = 'ok-soon-ai-search-query';
export const ANALYTICS_CHAT_ID = 'ok-soon-ai-analytics-chat-ids';
export const ANALYTICS_RECO_FROM = 'ok-soon-ai-reco-from';
